"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../Icon/index");
var _VisuallyHidden = require("../VisuallyHidden/VisuallyHidden");
var _DropdownIcon = require("./DropdownIcon.styles");
var _excluded = ["children", "icon"];
/**
 * The default variant for `DropdownPopper`.
 *
 * @related [`Dropdown`]
 * @since 7.28.0
 */
var DropdownIcon = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    icon = _ref.icon,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_DropdownIcon.StyledDropdownIcon, (0, _extends2.default)({}, rest, {
    ref: forwardedRef
  }), icon, children);
});
exports.DropdownIcon = DropdownIcon;
DropdownIcon.displayName = 'DropdownIcon';
DropdownIcon.propTypes = {
  /**
   * You can use the children prop to provide a
   * `VisuallyHidden` label.
   */
  children: _propTypes.default.node,
  /**
   * The `Icon` used as a trigger.
   */
  icon: _propTypes.default.node
};
DropdownIcon.defaultProps = {
  children: /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, null, "Show more"),
  icon: /*#__PURE__*/_react.default.createElement(_index.IconMore, null)
};